import React, { useEffect, useState } from 'react';
import { $, useModuleDefinition } from '@starberry/components';
import { useBreakpointValue } from "@chakra-ui/react"

const MyLatestPropertyComponent = () => {
  const [detectDevice, setDetectDevice] = useState(false);
  const breakpointValue = useBreakpointValue({ base: true, lg: false });

  useEffect(() => {
    setDetectDevice(breakpointValue)
  }, [breakpointValue]);

  const MyLatestPropertyModule = useModuleDefinition({
    $: 'PropertyResults',
    template: {
      $: 'PropertyItem',
      horizontal: detectDevice,
      showRooms: true,
      showPrice: false,
    },
    gridProps: {
      gap: $('constants.globalGridGap'),
    },
    limit: 3,
    config: ({ limit }) => ({
      limit: limit,
      data: 'state.myaccount.0.latestProperties',
      provide: ['myaccount'],
      // provide: ['properties'],
      // data: 'items',
    }),
    props: {
      color: 'gray.600',
    },
  })

  return <MyLatestPropertyModule />
}

const MyLatestProperty = {
  component: MyLatestPropertyComponent
}

export default MyLatestProperty;